module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/NonAutorizzato.98dd1bd3.png";